import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

interface Props {
  elOpacity: boolean;
}

const SliderBackgroundContainer = styled.div<Props>`
  opacity: ${(props) => (props.elOpacity ? 1 : 0)};
  position: absolute;
  left: -16%;
  top: 0;
`;

export default withAnimation(SliderBackgroundContainer);
